window.axios = require("axios");

class WishlistQf {
  constructor() {
    this.LOCAL_STORAGE_WISHLIST_KEY = "shopify-wishlist";
    this.LOCAL_STORAGE_DELIMITER = ",";
    this.BUTTON_ACTIVE_CLASS = "active-wishlist";
    this.GRID_LOADED_CLASS = "loaded";

    this.selectors = {
      button: "[button-wishlist]",
      clearWishlist: ".clear-wishlist",
      grid: "[grid-wishlist]",
      productCard: ".product-card",
      shortlist: "[grid-shortlist]",
      shortlist_btn: ".shortlist-btn",
      modal: ".wishlist-modal",
      modalContainer: ".wishlist-modal-container",
      closeModal: ".close-wishlist-modal",
      removeSingle: ".remove-button",
      wishlistCounter: "[wishlistCounter]"
    };

    this.init()
  }

  init() {
    this.initButtons();
    this.updateWishlistCounter()
    this.initGrid().then(() => {
      this.buttonCheck();
    })
  }

  buttonCheck() {
    let vm = this;
    let buttons = document.querySelectorAll(vm.selectors.button);
    buttons.forEach((button) => {
      const productHandle = button.dataset.productHandle || false;
      if (vm.wishlistContains(productHandle)) {
        button.classList.add(vm.BUTTON_ACTIVE_CLASS);
      } else button.classList.remove(vm.BUTTON_ACTIVE_CLASS);
    })
  }

  initButtons = () => {
    let vm = this;
    document.body.addEventListener('click', function (e) {
      const button = e.target.closest(vm.selectors.button);
      const modal = e.target.closest(vm.selectors.modal) || false;
      const grid = document.querySelector(vm.selectors.grid) || false;

      if (button) {
        const productHandle = button.dataset.productHandle || false;

        if (!productHandle) {
          return console.error(
            "[Shopify Wishlist] Missing `data-product-handle` attribute. Failed to update the wishlist."
          );
        }
        vm.updateWishlist(productHandle);
        vm.updateWishlistCounter()
        let allButtonsForHandle = document.querySelectorAll(
          `${vm.selectors.button}[data-product-handle="${productHandle}"]`
        );
        if (allButtonsForHandle) {
          allButtonsForHandle.forEach((buttonAddClass) => {
            buttonAddClass.classList.toggle(vm.BUTTON_ACTIVE_CLASS);
          });
        }

        if(modal) {
          modal.classList.remove('open');
        }

        if (grid) {
          const productHandleRemoving = button.dataset.productHandle || false;
          if (!productHandleRemoving) {
            return console.error(
              "[Shopify Wishlist] Missing data-product-handle attribute. Failed to update the wishlist."
            );
          }

          vm.initGrid()
          vm.buttonCheck()
        }

        if(button.closest('.shortlist-section')){
          button.closest('.swiper-slide').remove()
        }
      }

      const clearButton = e.target.closest(vm.selectors.clearWishlist);
      if (clearButton) {
        vm.resetWishlist();
        vm.initGrid()
      }

      const closeModalButton = e.target.closest(vm.selectors.closeModal);
      if (closeModalButton) {
        modal.classList.remove('open');
      }

      let removeSingleProducts = e.target.closest(vm.selectors.removeSingle);
      if(removeSingleProducts){
        const productHandleRemoving = removeSingleProducts.dataset.productHandle || false;
        if (!productHandleRemoving) {
          return console.error(
            "[Shopify Wishlist] Missing `data-product-handle` attribute. Failed to update the wishlist."
          );
        }
        vm.updateWishlist(productHandleRemoving);
        vm.updateWishlistCounter()
        vm.initGrid()
        vm.buttonCheck()
      }

      const wishlistContainer = e.target.closest(vm.selectors.modalContainer) || false;
      
      if(modal && !wishlistContainer) {
        modal.classList.remove('open');
      }
    });

    document.dispatchEvent(new CustomEvent("shopify-wishlist:init-buttons", {
      detail: { wishlist: vm.getWishlist() },
    }));
  };

  wishlistContains = (handle) => {
    const wishlist = this.getWishlist();
    return wishlist.includes(handle);
  };

  getWishlist = () => {
    const wishlist = localStorage.getItem(this.LOCAL_STORAGE_WISHLIST_KEY) || false;
    if (wishlist) return wishlist.split(this.LOCAL_STORAGE_DELIMITER);
    return [];
  };

  updateWishlist = (handle) => {
    const wishlist = this.getWishlist();
    const indexInWishlist = wishlist.indexOf(handle);
    if (indexInWishlist === -1) wishlist.push(handle);
    else wishlist.splice(indexInWishlist, 1);
    return this.setWishlist(wishlist);
  };

  setWishlist = (array) => {
    const wishlist = array.join(this.LOCAL_STORAGE_DELIMITER);
    if (array.length) {
      localStorage.setItem(this.LOCAL_STORAGE_WISHLIST_KEY, wishlist);
      document.dispatchEvent(new CustomEvent("shopify-wishlist:updated", {
        detail: { wishlist: array },
      }));
    } else {
      localStorage.removeItem(this.LOCAL_STORAGE_WISHLIST_KEY);
      window.log("wishlist had no length");
    }
  }

  resetWishlist = () => {
    let vm = this;
    let allWishlistButtons = document.querySelectorAll(vm.selectors.button);
    allWishlistButtons.forEach((button) => {
      button.classList.remove(vm.BUTTON_ACTIVE_CLASS);
    });
    return vm.setWishlist([]);
  };

  updateWishlistCounter = () => {
    let vm = this;
    let wishlistNumber = this.getWishlist().length;
    let wishlistCounterContainer = document.querySelectorAll(vm.selectors.wishlistCounter)

    if(wishlistNumber > 0){
      wishlistCounterContainer.forEach(el => {
        el.innerHTML = wishlistNumber
        el.classList.remove('is-hidden')
      })
    }else{
      wishlistCounterContainer.forEach(el => {
        el.classList.add('is-hidden')
      })
    }
  }

  initYotpo() {
    if (window.yotpoWidgetsContainer && typeof window.yotpoWidgetsContainer.initWidgets === 'function') {
      window.yotpoWidgetsContainer.initWidgets();
    } else {
      setTimeout(initYotpo, 500);
    }
  }

  initGrid = async () => {
    let vm = this;
    let grid = false;
    if (document.querySelector(this.selectors.grid)) {
      grid = document.querySelector(this.selectors.grid);
    } else if (document.querySelector(this.selectors.shortlist)) {
      grid = document.querySelector(this.selectors.shortlist);
    }

    if (grid) {
      grid.innerHTML = "";
      const wishlist = this.getWishlist();
      let step = 1;
      if (wishlist.length) {
        if (grid) {
          grid.classList.remove('empty');
        } else shortlistGrid.classList.remove('empty');
      } else {
        if (grid) {
          grid.classList.add('empty');
        } else shortlistGrid.classList.add('empty');
      }

      await wishlist.forEach(function (handle, index) {
        let productTileTemplateUrl = window.Shopify.routes.root + `products/${handle}?view=card`;
        axios.get(productTileTemplateUrl, {})
          .then((response) => {
            if (response.status == 200) {
              const htmlDocument = new DOMParser().parseFromString(response.data, "text/html");
              const productCard = htmlDocument.documentElement.querySelector(
                vm.selectors.productCard
              );

              window.log("RESPONSE:", productCard);

              

              if(grid) {
                grid.insertAdjacentHTML(
                  'afterbegin',
                  `<div class="swiper-slide">${productCard.outerHTML}</div>`
                )
                vm.buttonCheck()
              } else if (index < 5) {
                shortlistGrid.insertAdjacentHTML(
                  'afterbegin',
                  `<div class="swiper-slide">${productCard.outerHTML}</div>`
                )
              }
              
              if(grid) {
                vm.initShortListSwiper(grid)
              }
              
              vm.initYotpo();

              step++
            }
          })
      })

      if(grid) {
        grid.classList.add(vm.GRID_LOADED_CLASS);
      }

      document.dispatchEvent(new CustomEvent("shopify-wishlist:init-product-grid", {
        detail: { wishlist: wishlist },
      }));
    }
  };

  initShortListSwiper = (shortlistGrid) => {
    let wrapper = shortlistGrid.closest('.shopify-shortlist');

    let swiper = new window.swiper(wrapper, {
      slidesPerView: 1.5,
      spaceBetween: 30,
      breakpoints: {
        425: {
          slidesPerView: 2
        },
        680 : {
          slidesPerView: 3
        },
        992: {
          slidesPerView: 4
        },
        1150: {
          slidesPerView: 5
        }
      }
    });
  }
}

window.WishlistQf = WishlistQf;